import { render, staticRenderFns } from "./HeaderCaption.vue?vue&type=template&id=7c1b3464&scoped=true&"
var script = {}
import style0 from "./HeaderCaption.vue?vue&type=style&index=0&id=7c1b3464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b3464",
  null
  
)

export default component.exports